export { default } from "./MainPoints";
